import "./scss/style.scss";
import { telCancel } from "./js/tel-cancel.js";
import { smoothScroll } from "./js/smoothscroll.js";
/*import { planTab } from "./js/plan-tab";
import { rollover } from "./js/rollover";*/

document.addEventListener('DOMContentLoaded', telCancel);
document.addEventListener('DOMContentLoaded', smoothScroll);
/*planTab();
rollover();*/